import type { FC, MutableRefObject } from 'react'
import { useEffect, useCallback, useRef } from 'react'
import { useCartModal } from 'hooks'
import ClickOutside from 'helpers/click-outside'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { Button } from 'components/ui'
// import Router from 'next/router'
// import { ROUTE_CART_INDEX } from 'routes/cart'
import s from './cart-widget.module.css'
import type { CartWidgetProps } from '.'

const CartWidget: FC<CartWidgetProps> = ({ children }) => {
  const { cartModal, toggleCartModal } = useCartModal()

  const ref = useRef() as MutableRefObject<HTMLDivElement>

  const closeCartModal = useCallback(() => toggleCartModal(), [toggleCartModal])

  const handleKey = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeCartModal()
      }
    },
    [closeCartModal],
  )

  useEffect(() => {
    if (ref.current) {
      if (cartModal) {
        disableBodyScroll(ref.current)
        window.addEventListener('keydown', handleKey)
      } else {
        enableBodyScroll(ref.current)
      }
    }
    return () => {
      window.removeEventListener('keydown', handleKey)
      clearAllBodyScrollLocks()
    }
  }, [cartModal, handleKey])

  // function handleClick() {
  //   closeCartModal()
  //   Router.push(ROUTE_CART_INDEX)
  // }

  if (!cartModal) {
    return null
  }

  return (
    <section className={s.root} ref={ref}>
      <aside className={s.backdrop} />
      <ClickOutside active onClick={closeCartModal}>
        <aside className={s.content}>
          {children}
          <Button variant="ghost" onClick={closeCartModal} className={s.buttonClose}>
            Voltar
          </Button>
        </aside>
      </ClickOutside>
    </section>
  )
}

export default CartWidget
